import useTracking from './useTracking';

export default useTracking;
